import { useCarouselContext } from "@aviary/components/Carousel/CarouselContext";

import { CarouselSpecializedRadio } from "./CarouselSpecializedRadio";

import * as styles from "./CarouselRadio.styles";

/** @deprecated Please use NewCarousel instead */
const CarouselRadio = () => {
  const { activeIndex, setActiveIndex, carouselItemsCount, setDirection, itemsToShow } =
    useCarouselContext();
  const resolvedItemsToShow = itemsToShow ?? 1;

  const handleChange = (i: number) => {
    const newActiveIndex = i * resolvedItemsToShow;
    setActiveIndex(newActiveIndex);
    setDirection(newActiveIndex > activeIndex ? "right" : "left");
  };

  const radiosCount = Math.ceil(carouselItemsCount / resolvedItemsToShow);

  if (radiosCount <= 1) return null;

  const activeRadio = Math.floor(activeIndex / resolvedItemsToShow);

  return (
    <div css={styles.carouselRadio}>
      {Array.from({ length: radiosCount }).map((_, i) => {
        return (
          <CarouselSpecializedRadio
            key={i}
            checked={activeRadio === i}
            onChange={() => handleChange(i)}
          />
        );
      })}
    </div>
  );
};

export { CarouselRadio };
